import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { EmployeeModuleMenuService } from '@app/modules/employees/services/employee-module-menu.service';
import {
    EMPLOYEE_INDEX,
    OfferLetterCreationReferer,
} from '@app/modules/offer-letter/types/offer-letter-referer-view.type';
import { AnalyticService } from '@app/services';
import { AuthService } from '@app/services/auth.service';
import { IndexView } from '@common/views';
import { EmployeesIndexTable } from '@employees/services/tables/employee-table/employees-index.table';
import { HireEmployee } from '@settings/meta/module-feature-permissions.meta';
@Component({
    templateUrl: './employee-index.template.html',
    styleUrls: ['./employee-index.style.scss'],
})
export class EmployeeIndexView extends IndexView implements OnInit {
    isLoading = false;
    hasHiringPermissions = false;
    isCreateEmployeeDialogOpen = false;
    table: EmployeesIndexTable | undefined;

    constructor(
        private auth: AuthService,
        private router: Router,
        private route: ActivatedRoute,
        private analyticService: AnalyticService,
        public employeeModuleMenuService: EmployeeModuleMenuService
    ) {
        super();

        this.hasHiringPermissions = this.auth.can(HireEmployee.permissions);
    }

    async ngOnInit(): Promise<void> {
        this.table = new EmployeesIndexTable(this.auth);
    }

    onCreate(): void {
        this.isCreateEmployeeDialogOpen = true;
    }

    onNewHire(): void {
        this.analyticService.trackEvent(AnalyticEvents.CreateEmployeeClickHireEmployee);
        this.router.navigate(['create'], { relativeTo: this.route });
    }

    onSendOffer(): void {
        const referer: OfferLetterCreationReferer = EMPLOYEE_INDEX;
        const refererQueryParam = { queryParams: { referer } };

        this.isCreateEmployeeDialogOpen = false;
        this.router.navigate(['/employees', 'offer-letters', 'new'], refererQueryParam);
    }
}
